export default {"src":"/_next/static/media/de.09bcffb3.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};